import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DependentDetailForm } from 'Components/ComponentLibrary/Organisms/DependentDetailForm/DependentDetailForm';
import { FDDialogContent, FDPrimaryActionButton } from '@facet-wealth/design';
import { DialogActions, DialogTitle } from 'Views/Page/Content/Modal/Components';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

export const DependentLayout = () => {
  const { resource, onSubmit } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  const handleSubmit = async () => {
    const resp = await onSubmit();

    if (resp) {
      clearModalCollection();
    }
  };

  return (
    <>
      <DialogTitle value={(resource.id() !== undefined) ? 'Edit Member' : 'Create Member'} />
      <FDDialogContent>
        <DependentDetailForm />
      </FDDialogContent>
      <DialogActions>
        <FDPrimaryActionButton
          onClick={handleSubmit}
          label={'Save Changes'}
        />
      </DialogActions>
    </>
  );
};
